const BreadCrumbsData = {
  PrivacyPolicy: {
    links: [
      {
        title: "מדיניות הפרטיות",
        link: "/privacy-policy",
      },
    ],
  },

  TermsOfUse: {
    links: [
      {
        title: "תנאי שימוש",
        link: "/terms-of-use",
      },
    ],
  },
  Accessibility: {
    links: [
      {
        title: "הצהרת נגישות",
        link: "/accessibility",
      },
    ],
  },
  SiteMap: {
    links: [{ title: "מפת אתר", link: "/sitemap" }],
  },
  Recall: {
    links: [
      {
        title: "קריאות חוזרות",
        link: "/recall",
      },
    ],
  },
  Warranty: {
    links: [
      {
        title: "כתב אחריות",
        link: "/warranty",
      },
    ],
  },
  ServiceInstructions: {
    links: [
      {
        title: "הוראות שירות",
        link: "/service-instructions",
      },
    ],
  },
  WarrantyExtension: {
    links: [{ title: "בדיקת תכולת הארכת אחריות", link: "/warranty-extension" }],
  },
  SparePriceList: {
    links: [
      {
        title: "מחירון מוצרי תעבורה",
        link: "/spare-price-list",
      },
    ],
  },
  ColorCode: {
    links: [
      {
        title: "קוד צבע",
        link: "/color-code",
      },
    ],
  },
  Hamesayat: {
    links: [
      {
        title: "המסייעת",
        link: "/hamesayat",
      },
    ],
  },
  VideoTutorials: {
    links: [
      {
        title: "סרטוני הדרכה ותפעול",
        link: "/video-tutorials",
      },
    ],
  },
  ServicesCenters: {
    links: [
      {
        title: "מרכזי שירות",
        link: "/services-centers",
      },
    ],
  },
  ShowRooms: {
    links: [
      {
        title: "אולמות תצוגה",
        link: "/show-rooms",
      },
    ],
  },
  CarList: {
    links: [
      {
        title: "מחירון מכוניות",
        link: "/car-list",
      },
    ],
  },
  Insurance: {
    links: [
      {
        title: "ביטוח",
        link: "/insurance",
      },
    ],
  },
  CarFleets: {
    links: [
      {
        title: "ציי רכב",
        link: "/car-fleets",
      },
    ],
  },
  ContactUs: {
    links: [
      {
        title: "צרו קשר",
        link: "/contact-us",
      },
    ],
  },
  ServicePlans: {
    links: [
      {
        title: "תוכנית טיפול",
        link: "/service-plans",
      },
    ],
  },
}

export { BreadCrumbsData }
